import React from 'react';
import useTranslation from './useTranslation';

const LoadingSkeletonRouteList = () => {
  const { t } = useTranslation();
  
  // Crea un array di 3 elementi per simulare il caricamento di 3 percorsi
  const skeletonRoutes = [1, 2, 3];
  
  return (
    <main>
      <div className="container">
        <section className="mt-2 mb-4">
          {/* Skeleton per il titolo */}
          <div 
            className="pulse"
            style={{
              height: '32px',
              width: '30%',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px',
              marginBottom: '12px'
            }}
          />
          
          {/* Skeleton per il sottotitolo */}
          <div 
            className="pulse"
            style={{
              height: '18px',
              width: '70%',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px'
            }}
          />
        </section>
        
        <div className="gy-2">
          {skeletonRoutes.map((_, index) => (
            <div key={index} className="mb-3">
              <div className="position-relative shadow-sm rounded overflow-hidden">
                <div className="position-relative" style={{ minHeight: '200px', backgroundColor: '#e0e0e0' }}>
                  {/* Simulazione sfondo immagine */}
                  <div className="pulse" style={{ height: '100%', width: '100%' }} />
                  
                  <div className="position-relative p-4 text-white text-start" style={{ zIndex: 2 }}>
                    {/* Skeleton per le metriche del percorso (tempo, tappe, distanza) */}
                    <div className="d-flex justify-content-between mb-3 flex-fill">
                      {[1, 2, 3].map((_, i) => (
                        <div 
                          key={i} 
                          className="pulse"
                          style={{
                            height: '16px',
                            width: '60px',
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            borderRadius: '4px'
                          }}
                        />
                      ))}
                    </div>
                    
                    {/* Skeleton per il titolo del percorso */}
                    <div 
                      className="pulse"
                      style={{
                        height: '24px',
                        width: '70%',
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        borderRadius: '4px',
                        marginBottom: '12px'
                      }}
                    />
                    
                    {/* Skeleton per la descrizione */}
                    <div 
                      className="pulse mb-3"
                      style={{
                        height: '48px',
                        width: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        borderRadius: '4px'
                      }}
                    />
                    
                    {/* Skeleton per il pulsante */}
                    <div className="text-start">
                      <div 
                        className="pulse"
                        style={{
                          height: '32px',
                          width: '120px',
                          backgroundColor: 'rgba(255, 255, 255, 0.5)',
                          borderRadius: '999px'
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LoadingSkeletonRouteList;